import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformCatalogCategoriesResponse, transformCatalogCategoryResponse } from './transformers.js';
import { flatToTree } from '../../utils/index.js';
import defaultClient from 'axios';

const getCatalogCategoriesTree = async ({ client , controller , fields ={} , where ={} , order =[] , limit =1000000 , offset =0 , skip =0  } = {})=>{
    const { data: allCategoryItems  } = await client.get(`V1/catalog/categories/tree`, {
        signal: controller?.signal,
        params: {
            filter: {
                fields,
                where,
                order,
                limit,
                offset,
                skip
            }
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogCategoriesResponse)
        ]
    });
    return {
        data: flatToTree({
            list: allCategoryItems,
            children: allCategoryItems,
            level: 2
        })
    };
};
getCatalogCategoriesTree.key = 'getCatalogCategoriesTree';
const getCatalogCategory = async ({ client , controller , id  } = {})=>await client.get(`V1/catalog/categories/${id}`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogCategoryResponse)
        ]
    });
getCatalogCategory.key = 'getCatalogCategory';
const getCatalogCategories = async ({ client , controller , fields , where ={} , order =[] , limit =1000000 , offset =0 , skip =0  } = {})=>await client.get(`V1/catalog/categories`, {
        signal: controller?.signal,
        params: {
            filter: {
                fields,
                where,
                order,
                limit,
                offset,
                skip
            }
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCatalogCategoriesResponse)
        ]
    });
getCatalogCategories.key = 'getCatalogCategories';

export { getCatalogCategories, getCatalogCategoriesTree, getCatalogCategory };
